import { light as theme } from '@leroy-merlin-br/backyard-theme'

export const STATUS_DATA = {
  7: {
    icon: 'liked',
    iconText: 'Aprovado',
    color: theme.colors.p500,
    text: ''
  },
  8: {
    icon: 'liked',
    iconText: 'Aprovação',
    color: theme.colors.n200,
    text:
      'Agora falta pouco! Seu documento já está com a gente e a análise será feita em até 4 dias úteis.'
  },
  10: {
    icon: 'close',
    iconText: 'Reprovado',
    color: theme.colors.r500,
    text: ''
  },
  11: {
    icon: 'close',
    iconText: 'Reprovado',
    color: theme.colors.r500,
    text: ''
  }
}
